import { useTranslation } from 'react-i18next';

import { EmptyPlaceholder } from '@client/toolkit';

/** Tabs that have no content yet. Typed so a typo fails the build instead of rendering a raw key. */
export type PlaceholderTabKey = 'summary' | 'budgetStatus' | 'operations' | 'settlement' | 'companyCosts';

export interface EconomyTabPlaceholderProps {
  /** Key under `economy:tabs` naming the tab that is not built yet. */
  tabKey: PlaceholderTabKey;
}

export function EconomyTabPlaceholder({ tabKey }: EconomyTabPlaceholderProps) {
  const { t } = useTranslation('economy');

  return <EmptyPlaceholder className="mt-8">{t('tabPlaceholder', { tab: t(`tabs.${tabKey}`) })}</EmptyPlaceholder>;
}

export default EconomyTabPlaceholder;
